import { Skeleton } from '@/ui/components/common/Skeleton'

/**
 * Placeholder skeleton for a single investigator card while data loads.
 * Mirrors the silhouette of an avatar followed by name and bio lines.
 */
export function AvatarSkeleton() {
  return (
    <div className="flex flex-col items-center gap-3 p-6">
      <Skeleton className="w-24 h-24 rounded-full" />
      <Skeleton className="h-4 w-28" />
      <Skeleton className="h-3 w-40" />
      <Skeleton className="h-3 w-36" />
    </div>
  )
}
